import React from 'react'

import { METRICS_TYPES } from '../constants'

export const showMetric = (value, type) => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (type) {
    case METRICS_TYPES.SURFACE:
      return (
        <span>
          {value} m<sup>2</sup>
        </span>
      )
    default:
      return value
  }
}
